import { createFileRoute } from '@tanstack/react-router';

import SetupTournament from '~/setup/tournament/SetupTournament';

export const Route = createFileRoute('/_protected/tournaments/')({
  validateSearch: (search: Record<string, unknown>) => ({
    tournamentId: typeof search.tournamentId === 'string' ? search.tournamentId : undefined,
  }),
  component: SetupTournament,
});
